import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { T } from "@/lib/content";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ibk-lang") || "de");
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem("ibk-theme");
    if (stored) return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    localStorage.setItem("ibk-theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("ibk-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleTheme = useCallback(() => setTheme((p) => (p === "dark" ? "light" : "dark")), []);
  const toggleLang = useCallback(() => setLang((p) => (p === "de" ? "en" : "de")), []);

  return (
    <SiteContext.Provider value={{ lang, theme, toggleTheme, toggleLang, t: T[lang] }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
};
